import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import useApi from '../hooks/useApi';

const CodatCallback = () => {
  const navigate = useNavigate();
  const api = useApi();

  useEffect(() => {
    if (api) {
      api
        .syncCategories()
        .then((data) => {
          navigate('/');
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [api, navigate]);

  return <div></div>;
};

export default CodatCallback;
